module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-BoldItalic.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-BoldItalic.eot
 ** module id = 351
 ** module chunks = 0
 **/